(() => {
  document.querySelectorAll('product-page.main-product').forEach(page => {
    const picker = page.querySelector('product-variants');
    const mainButton = page.querySelector('[data-js-product-add-to-cart]');
    const bar = document.querySelector(`sticky-add-to-cart[data-id="${page.id}"]`);
    if (!mainButton) return;
    const stickyButton = bar?.querySelector('button');
    const footer = document.querySelector('.main-footer');
    if (bar && footer && 'IntersectionObserver' in window) {
      const footerObserver = new IntersectionObserver(entries => {
        bar.toggleAttribute('data-nl4-footer-visible', entries.some(entry => entry.isIntersecting));
      });
      footerObserver.observe(footer);
    }
    let previewObserver;
    const alignPreview = () => {
      const frame = document.getElementById('PBarNextFrame');
      if (!bar || !frame) return;
      const position = () => bar.style.setProperty('--nl4-preview-offset',`${Math.min(70,Math.ceil(frame.getBoundingClientRect().height))}px`);
      position();
      if (!previewObserver && 'ResizeObserver' in window) {previewObserver = new ResizeObserver(position); previewObserver.observe(frame);}
    };
    alignPreview();
    addEventListener('load',() => {alignPreview(); setTimeout(alignPreview,1500);},{once:true});
    setTimeout(alignPreview,3000);
    const update = (syncGallery = false) => {
      const summary = page.querySelector('[data-nl4-summary]');
      if (!summary) return;
      alignPreview();
      const ready = summary.dataset.ready === 'true' && summary.dataset.available === 'true';
      if (bar) {
        const price = bar.querySelector('.sticky-add-to-cart__price');
        if (price) {
          const badge = page.querySelector('[data-update-block="price-compact"] .nl-rendl-card-price');
          const amount = document.createElement('span');
          amount.className = 'nl8-sticky-price__amount';
          amount.textContent = badge?.querySelector('strong')?.textContent.trim() || summary.dataset.price || '';
          const noteText = badge?.querySelector('span')?.textContent.trim();
          const signature = `${amount.textContent}|${noteText || ''}`;
          if (price.dataset.nl8Signature !== signature) {
            price.replaceChildren(amount);
            if (noteText) {
              const note = document.createElement('small');
              note.className = 'nl8-sticky-price__note';
              note.textContent = noteText;
              price.append(note);
            }
            price.dataset.nl8Signature = signature;
          }
        }
        let variant = bar.querySelector('.nl4-sticky-variant');
        if (!variant) {variant = document.createElement('span'); variant.className = 'nl4-sticky-variant'; bar.querySelector('.sticky-add-to-cart__title')?.append(variant);}
        if (variant) variant.textContent = summary.dataset.title || '';
        if (stickyButton && bar.hasAttribute('data-multiple')) {
          const buttonText = stickyButton.querySelector('.button__text');
          const mainText = mainButton.querySelector('[data-js-product-add-to-cart-text]');
          if (buttonText) buttonText.textContent = ready ? (mainText?.textContent.trim() || buttonText.textContent) : (page.dataset.nl4ChooseLabel || buttonText.textContent);
        }
        if (stickyButton && bar.hasAttribute('data-single')) stickyButton.disabled = mainButton.disabled || mainButton.classList.contains('disabled');
      }
      if (syncGallery && summary.dataset.mediaId) {
        const media = page.querySelector(`[data-media-id="${summary.dataset.mediaId}"]`);
        const thumbnail = media && page.querySelector(`.product-gallery__thumbnails button[data-index="${media.dataset.index}"]`);
        thumbnail?.click();
      }
    };
    picker?.addEventListener('VARIANT_CHANGE',() => update(true));
    new MutationObserver(() => update()).observe(mainButton,{attributes:true,childList:true,subtree:true});
    const priceBlock = page.querySelector('[data-update-block="price-compact"]');
    if (priceBlock) new MutationObserver(() => update()).observe(priceBlock,{childList:true,subtree:true});
    if (stickyButton && bar.hasAttribute('data-multiple')) {
      stickyButton.addEventListener('click',event => {
        const summary = page.querySelector('[data-nl4-summary]');
        if (summary?.dataset.ready !== 'true' || summary.dataset.available !== 'true' || mainButton.disabled || mainButton.classList.contains('disabled')) {
          event.preventDefault();
          event.stopImmediatePropagation();
          const options = picker || page.querySelector('.product-variants');
          if (options) {
            options.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            const control = options.querySelector('select:not(:disabled),input:not(:disabled),button:not(:disabled)');
            if (control) { try { control.focus({ preventScroll: true }); } catch (_) { control.focus(); } }
          }
          return;
        }
        event.preventDefault(); event.stopImmediatePropagation(); mainButton.click();
      },true);
    }
    update();
  });
})();


